import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { variables } from '@domain-group/fe-brary';
import { SearchIcon } from '@domain-group/fe-co-icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref2 = {
  name: "1n2mv2k",
  styles: "display:flex;justify-content:center;align-items:center;"
};
var PlaceholderIcon = _ref => {
  var className = _ref.className;
  return ___EmotionJSX("div", {
    className: className,
    css: _ref2
  }, ___EmotionJSX(SearchIcon, {
    size: "custom",
    css: /*#__PURE__*/_css({
      height: '22px',
      width: '22px',
      color: variables.colour.neutral400
    })
  }));
};
PlaceholderIcon.propTypes = {
  className: PropTypes.string
};
PlaceholderIcon.defaultProps = {
  className: ''
};
export default PlaceholderIcon;